import logo from "./cube_cat.png";
import "./Logo.css";

function Logo() {
  return <img src={logo} className="Logo" alt="rmariondotcom logo" />;
}

export default Logo;
